import {calculatorSvg as Icon__small__calculatorSvg} from '../Icon__small/Icon__small--calculator.js';

export var calculator = {
  name: 'calculator',
  category: 'icon',
  colorable: true,
  svg: Icon__small__calculatorSvg,
};
